export default __webpack_public_path__ + "static/media/FONSECA.39f7c003.webp";